module.exports = __webpack_public_path__ + "static/medios-think-c2b27061bc414f44c34a09fb05a3bcd7.png";